if (window.navigator && window.navigator.serviceWorker) {
  window.navigator.serviceWorker.register("/serviceworker.js")
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error)
    })
}
